
import { RequestBody } from "./RequestBody"
export class Login extends RequestBody{
    emailOrMobileNo:string =''
    password:string =''
}